import { render } from "./BlacklistEditor.html?vue&type=template&id=42a1441e&ts=true&external"
import script from "./BlacklistEditor.vue?vue&type=script&lang=ts"
export * from "./BlacklistEditor.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__